export enum ErrorReason {
  Unknown,
  NoInternet,
  Validation,
  ApplicationError,
  Unimplemented,
  Unavailable,
  UserCanceled
}
